module.exports = __webpack_public_path__ + "img/Nutridome00090047.b08218be.jpg";